<template>
<div class="chapter">
<div class="inner_page">
<div id="Stranded_eBook-3.html" xml:lang="en-US">
<div class="Basic-Text-Frame">
<p class="EB para-style-override-4" id="toc_marker-4"><span class="char-style-override-7">Also by Val McDermid</span></p>
<p class="BT1stPara para-style-override-6"><span class="char-style-override-5">A Place of Execution</span></p>
<p class="BT1stPara para-style-override-1"><span class="char-style-override-5">Killing the Shadows</span></p>
<p class="BT1stPara para-style-override-1"><span class="char-style-override-5">The Distant Echo</span></p>
<p class="BT1stPara para-style-override-1"><span class="char-style-override-5">The Grave Tattoo</span></p>
<p class="BT1stPara para-style-override-1"><span class="char-style-override-5">A Darker Domain</span></p>
<p class="BT1stPara para-style-override-1"><span class="char-style-override-5">Trick of the Dark</span></p>
<p class="BT1stPara para-style-override-1"><span class="char-style-override-5">The Vanishing Point</span></p>
<p class="BT1stPara para-style-override-1"><span class="char-style-override-5">Northanger Abbey</span></p>
<p class="BT1stPara para-style-override-1"><span class="char-style-override-5">The Skeleton Road<a id="Anchor"></a></span></p><a id="Anchor">
<p class="BT1stPara para-style-override-6"><span class="char-style-override-8">TONY HILL NOVELS</span></p>
<p class="BT1stPara para-style-override-1"><span class="char-style-override-5">The Mermaids Singing</span></p>
<p class="BT1stPara para-style-override-1"><span class="char-style-override-5">The Wire in the Blood</span></p>
<p class="BT1stPara para-style-override-1"><span class="char-style-override-5">The Last Temptation</span></p>
<p class="BT1stPara para-style-override-1"><span class="char-style-override-5">The Torment of Others</span></p>
<p class="BT1stPara para-style-override-1"><span class="char-style-override-5">Beneath the Bleeding</span></p>
<p class="BT1stPara para-style-override-1"><span class="char-style-override-5">Fever of the Bone</span></p>
<p class="BT1stPara para-style-override-1"><span class="char-style-override-5">The Retribution</span></p>
<p class="BT1stPara para-style-override-1"><span class="char-style-override-5">Cross and Burn</span></p>
<p class="BT1stPara para-style-override-6"><span class="char-style-override-8">KATE BRANNIGAN NOVELS</span></p>
<p class="BT1stPara para-style-override-1"><span class="char-style-override-5">Dead Beat</span></p>
<p class="BT1stPara para-style-override-1"><span class="char-style-override-5">Kick Back</span></p>
<p class="BT1stPara para-style-override-1"><span class="char-style-override-5">Crack Down</span></p>
<p class="BT1stPara para-style-override-1"><span class="char-style-override-5">Clean Break</span></p>
<p class="BT1stPara para-style-override-1"><span class="char-style-override-5">Blue Genes</span></p>
<p class="BT1stPara para-style-override-1"><span class="char-style-override-5">Star Struck</span></p>
<p class="BT1stPara para-style-override-6"><span class="char-style-override-8">LINDSAY GORDON NOVELS</span></p>
<p class="BT1stPara para-style-override-1"><span class="char-style-override-5">Report for Murder</span></p>
<p class="BT1stPara para-style-override-1"><span class="char-style-override-5">Common Murder</span></p>
<p class="BT1stPara para-style-override-1"><span class="char-style-override-5">Final Edition</span></p>
<p class="BT1stPara para-style-override-1"><span class="char-style-override-5">Union Jack</span></p>
<p class="BT1stPara para-style-override-1"><span class="char-style-override-5">Booked for Murder</span></p>
<p class="BT1stPara para-style-override-1"><span class="char-style-override-5">Hostage to Murder</span></p>
<p class="BT1stPara para-style-override-6"><span class="char-style-override-8">SHORT STORY COLLECTIONS</span></p>
<p class="BT1stPara para-style-override-1"><span class="char-style-override-5">The Writing on the Wall</span></p>
<p class="BT1stPara para-style-override-1"><span class="char-style-override-5">Stranded</span></p>
<p class="BT1stPara para-style-override-1"><span class="char-style-override-5">Christmas is Murder</span></p>
<p class="BT1stPara para-style-override-6"><span class="char-style-override-8">NON FICTION</span></p>
<p class="BT1stPara para-style-override-1"><span class="char-style-override-5">A Suitable Job for a Woman</span></p>
<p class="BT1stPara para-style-override-1"><span class="char-style-override-5">Forensics</span></p>
</a></div><a id="Anchor">
</a></div><a id="Anchor">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Stranded_eBook3.vue?94639f5e